import confetti from 'canvas-confetti';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { GamePrizeType } from '../../interfaces/game';
import { WheelAudioService } from '../../services/wheel-audio.service';

@Component({
    selector: 'app-win-overlay',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './win-overlay.component.html',
    styleUrl: './win-overlay.component.scss',
})
export class WinOverlayComponent implements OnChanges {
    @Output() public readonly closed = new EventEmitter<void>();

    @Input() public prize: { name: string, image: string, type: GamePrizeType } | null = null;

    @Input() public standalone = false;

    public constructor(
        private readonly audio: WheelAudioService,
    ) {
        //
    }

    public dismiss(): void {
        this.closed.emit();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['prize'] && this.prize !== null) {
            this.celebrate();
        }
    }

    private celebrate(): void {
        this.audio.playCheer();
        confetti({ particleCount: 150, spread: 110, origin: { y: 0.55 } });
    }
}
